import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AllPagesExportService } from 'src/app/common/service/all-pages-export.service';

@Component({
  selector: 'app-fetch-progress-dialog',
  templateUrl: './fetch-progress-dialog.component.html',
  styleUrls: ['./fetch-progress-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FetchProgressDialogComponent {

  constructor(public exportService: AllPagesExportService) { }

  stop(): void {
    this.exportService.cancel();
  }
}
